import camelcaseKeys from 'camelcase-keys';
import { unescape } from 'html-escaper';
/**
 * Scriptタグ経由で取得した値をSingletonで保持するためのclass
 */
class SingletonScriptState {
    constructor() {
        // Scriptタグ内のエスケープされたJSON文字列をparseし、保持しておく
        this.categories = SingletonScriptState.formatScriptValueAsObject({
            isSnakeCase: false,
            selector: '#script_categories',
        });
        this.profile = SingletonScriptState.formatScriptValueAsObject({
            isSnakeCase: false,
            selector: '#script_profile',
        });
        this.auth = SingletonScriptState.formatScriptValueAsObject({
            isSnakeCase: false,
            selector: '#script_auth',
        });
        // 各項目のローディングが完了したかを判定
        this.isAllLoaded = [this.profile, this.categories, this.auth].every((v) => !v.isUndefined);
    }
    /**
     * Scriptタグ内のJSON文字列をparseしつつ読み込んで返す
     * @param options.isSnakeCase スネークケースで値を取得するか
     * @param options.selector DOMのセレクタ
     */
    static formatScriptValueAsObject(options) {
        const { isSnakeCase, selector } = options;
        /** 指定されたセレクタのDOM（Scriptタグから取得する挙動を想定） */
        const dom = document.querySelector(`script[type="application/json"]${selector}`);
        if (!dom) {
            // DOMが存在しない場合
            return {
                isUndefined: true,
                value: null,
            };
        }
        /** Scriptタグ内のエスケープされたJSON文字列 */
        const escapedJsonString = (dom.textContent || '').trim();
        if (!escapedJsonString) {
            // DOM内部にデータが存在しない場合
            return {
                isUndefined: false,
                value: null,
            };
        }
        /** JSON変換したオブジェクト */
        const json = JSON.parse(unescape(escapedJsonString));
        /** 引数の型としてparseされたオブジェクト */
        const result = (isSnakeCase ? json : camelcaseKeys(json, { deep: true }));
        return {
            isUndefined: false,
            value: result,
        };
    }
}
export const singletonScriptState = new SingletonScriptState();
